<template>
	<div class="redirect">
		<HeadModule :openTarget="'class/list'" />
		<div class="content">
			<div class="title">电巢学堂全新升级啦</div>
			<div class="text">
				<p>尊敬的用户您好:</p>
				<p class="hint">
					为了给您带来更好的学习体验，电巢学堂进行了全面升级，请前往新版网址进行学习。
					您之前购买的学习内容权益和资产数据已经完成迁移。
					如有疑问请联系平台客服<span>19925233395</span>。
				</p>
				<p>期待与您一起开启新的成长历程！</p>
			</div>
			<div class="text company">
				<p>电巢科技</p>
				<p class="companyTime">2024.9</p>
			</div>
		</div>

		<div class="skipBtn">
			<p>
				<span>前往新版电巢学堂</span>
				<img src="@/assets/image/icon/ic_next@3x.png" alt="">
				<WxOpenTag :extinfo="'class/list'"/>
			</p>
		</div>
	</div>
</template>

<script>
	import HeadModule from '@/components/HeadModule'
	import WxOpenTag from '@/components/WxOpenTag'
	
	export default {
		components: {
      HeadModule: HeadModule,
			WxOpenTag: WxOpenTag,
    },

		data(){
			return {
				courseId: this.$route.query.courseId,
			}
		},
	}
</script>

<style scoped>
	.redirect {
		box-sizing: border-box;
		height: 100%;
	}
	.content {
		box-sizing: border-box;
		padding: 1.5rem;
		font-size: 1.4rem;
		color: #666666;
	}

	.title {
		text-align: center;
		font-size: 2.1rem;
		font-weight: 600;
		color: #F53F3F;
		margin-top: 4.7rem;
	}

	.text {
		margin-top: 4rem;
		font-size: 1.5rem;
		color: #333333;
	}

	.hint {
		margin: 2rem 0;
	}

	.company {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}

	.companyTime {
		padding-right: .7rem;
	}

	.skipBtn {
		display: flex;
		justify-content: center;
		font-size: 1.4rem;
		margin-top: 9.6rem;
	}

	.skipBtn p {
		position: relative;
		width: 15rem;
		height: 4rem;
		padding: 0 3.2rem;
		background-color: red;
		border-radius: 4rem;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFF;
	}

	.skipBtn img {
		width: 1.6rem;
		margin-top: .2rem;
		margin-left: .2rem;
	}
</style>